import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { IRootState } from "@/interfaces";
import { AppModule } from "@/vuex/modules/app/app.index";

Vue.use(Vuex);

const store: StoreOptions<IRootState> = {
  state: {
    appName: "RIMGUARD INC",
    appVersion: "1.0.0"
  },
  modules: { AppModule },
  plugins: []
};

export default new Vuex.Store<IRootState>(store);
